import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-context-configuration',
  templateUrl: './context-configuration.component.html',
  styleUrls: ['./context-configuration.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class ContextConfigurationComponent implements OnInit {
 

  constructor(){ }
 
  ngOnInit() {
   
  }

 
}
